import { CARD_LIST_ROUTE, TabConfig } from '../../common';
import cardsLang from '../../lang/cards';

export const getCardTabConfig = (): TabConfig[] => [
    {
        label: cardsLang.TABS.CARD.LIST,
        link: CARD_LIST_ROUTE,
    },
];
